// รหัสคูปองที่ผู้ใช้คัดลอก/กด "เลือกคอร์สเลย" ไว้จากแถบ/ปุ่มลอย/ป๊อปอัป → ไปกรอกให้ที่ช่องคูปองหน้าชำระเงิน (ผู้ใช้ยังต้องกด "ใช้คูปอง" เอง)
const PENDING_KEY = 'pendingCoupon'

export const setPendingCoupon = (code: string) => { try { sessionStorage.setItem(PENDING_KEY, code.toUpperCase()) } catch { /* ไม่มี storage ก็ข้าม */ } }
export const getPendingCoupon = (): string => { try { return sessionStorage.getItem(PENDING_KEY) || '' } catch { return '' } }
export const clearPendingCoupon = () => { try { sessionStorage.removeItem(PENDING_KEY) } catch { /* ข้าม */ } }

/** คัดลอกรหัสลงคลิปบอร์ด + จำไว้ให้หน้าชำระเงิน — คืน true เมื่อคัดลอกสำเร็จ */
export async function copyCouponCode(code: string): Promise<boolean> {
  setPendingCoupon(code)
  try {
    await navigator.clipboard.writeText(code)
    return true
  } catch {
    try {
      const ta = document.createElement('textarea')
      ta.value = code
      ta.style.position = 'fixed'
      ta.style.opacity = '0'
      document.body.appendChild(ta)
      ta.select()
      const ok = document.execCommand('copy')
      document.body.removeChild(ta)
      return ok
    } catch {
      return false
    }
  }
}

const MONTH_SHORT = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.']
/** "2026-10-20T23:59:00" → "20 ต.ค. 2569" (อ่านจาก string ตรงๆ ไม่ผ่าน Date กัน timezone เพี้ยน) */
export function formatThaiDate(value: string | null | undefined): string {
  if (!value) return ''
  const [y, m, d] = value.slice(0, 10).split('-').map(Number)
  if (!y || !m || !d) return ''
  return `${d} ${MONTH_SHORT[m - 1]} ${y + 543}`
}
